import { HttpParams } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AppState } from '@app/reducers';
import { CustomDirectiveConfig, ModulesBasedApiSuffix } from '@app/shared';
import { PrimengCustomDialogComponent } from '@app/shared/components/primeng-custom-dialog';
import { ResponseMessageTypes } from '@app/shared/enums';
import { CrudService, RxjsService, SnackbarService } from '@app/shared/services';
import { IApplicationResponse } from '@app/shared/utils/interfaces.utils';
import { SAPStorageListAddEditModel, StorageListAddModel } from '@modules/inventory/models/storageLocation.model';
import { InventoryModuleApiSuffixModels } from '@modules/inventory/shared';
import { loggedInUserData } from '@modules/others';
import { UserLogin } from '@modules/others/models';
import { select, Store } from '@ngrx/store';
import { DialogService } from 'primeng/api';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

@Component({
  selector: 'app-storage-location-add-edit',
  templateUrl: './storage-location-add-edit.component.html',
  styleUrls: ['./storage-location-add-edit.component.scss'],
})
export class StorageLocationAddEditComponent implements OnInit {

  btnName: any;
  storageLocationAddEditForm: FormGroup;
  showStorageType: boolean = false;
  storageLocationDropdown: any = [];
  storageLocationDropdownTemp: any = [];
  storageTypeDropdown: any = [];
  storageLocationsId: any = [];
  loggedUser: UserLogin;
  storageCRMLocationDetails: FormArray;
  storageSAPLocationDetails: FormArray;
  getDetailsData: any = {};
  isAStringOnly = new CustomDirectiveConfig({ isAStringOnly: true });

  constructor(
    private store: Store<AppState>,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private formBuilder: FormBuilder,
    private crudService: CrudService,
    private rxjsService: RxjsService,
    private snackbarService: SnackbarService,
    private dialogService: DialogService,
  ) {
    this.storageLocationsId = this.activatedRoute.snapshot.queryParams.id;
    this.store.pipe(select(loggedInUserData)).subscribe((userData: UserLogin) => {
      if (!userData) return;
      this.loggedUser = userData;
    });
  }

  ngOnInit(): void {
    this.createStorageLocationManualAddForm();
    this.getStorageLocationDropdown();
    this.getStorageDropDownList();
    if (this.storageLocationsId) {
      this.btnName = "Update";
      this.getstorageLocationIdById().subscribe((response: IApplicationResponse) => {
        if (response.isSuccess && response.statusCode === 200) {
          this.storageCRMLocationDetails = response.resources;
          this.getDetailsData = response.resources;
          if (response.resources.isSAP) {
            this.showStorageType = true;
            this.storageLocationAddEditForm.get('selectType').patchValue(true);
            this.storageSAPLocationDetails = this.getStorageSAPLocationFormArray;
            this.storageSAPLocationDetails.push(this.createStorageSAPGroupForm(response.resources));
            this.getStorageSAPLocationFormArray.controls[0].get('storageLocationId').patchValue(response.resources.storageLocationId);

          }
          if (response.resources.isCRM) {
            this.showStorageType = false;
            this.storageLocationAddEditForm.get('selectType').patchValue(false);
            this.storageCRMLocationDetails = this.getStorageCRMLocationFormArray;
            this.storageCRMLocationDetails.push(this.createStorageCRMGroupForm(response.resources));
          }
        }
      });
    } else {
      this.btnName = "Create";
      this.storageCRMLocationDetails = this.getStorageCRMLocationFormArray;
      this.storageSAPLocationDetails = this.getStorageSAPLocationFormArray;
    }
    this.rxjsService.setGlobalLoaderProperty(false);
  }

  /* Get details */
  getstorageLocationIdById(): Observable<IApplicationResponse> {
    return this.crudService.get(
      ModulesBasedApiSuffix.INVENTORY,
      InventoryModuleApiSuffixModels.STORAGE_LOCATION,
      this.storageLocationsId
    );
  }

  /* Create formArray start */
  createStorageLocationManualAddForm(): void {
    this.storageLocationAddEditForm = this.formBuilder.group({
      selectType: [true],
      crmLocaionAddForm : this.createStorageCRMGroupForm(),
      sapLocaionAddForm : this.createStorageSAPGroupForm(),
      storageCRMLocationDetails: this.formBuilder.array([]),
      storageSAPLocationDetails: this.formBuilder.array([]),
    });
    this.showStorageType = true;
  }

  get getStorageCRMLocationFormArray(): FormArray {
    if (this.storageLocationAddEditForm !== undefined) {
      return this.storageLocationAddEditForm.get("storageCRMLocationDetails") as FormArray;
    }
  }

  get getStorageSAPLocationFormArray(): FormArray {
    if (this.storageLocationAddEditForm !== undefined) {
      return this.storageLocationAddEditForm.get("storageSAPLocationDetails") as FormArray;
    }
  }

  get getCrmLocaionAddForm(): FormGroup {
    if (this.storageLocationAddEditForm !== undefined) {
      return this.storageLocationAddEditForm.get("crmLocaionAddForm") as FormGroup;
    }
  }
  get getSapLocaionAddForm(): FormGroup {
    if (this.storageLocationAddEditForm !== undefined) {
      return this.storageLocationAddEditForm.get("sapLocaionAddForm") as FormGroup;
    }
  }
  changeStorageType() {
    let selectType = this.storageLocationAddEditForm.get('selectType').value;
    if (selectType) {
      this.showStorageType = true;
    }
    else {
      this.showStorageType = false;
    }
  }

  getStorageDropDownList() {
    this.crudService.get(
      ModulesBasedApiSuffix.INVENTORY,
      InventoryModuleApiSuffixModels.UX_STORAGE_LOCATION_PREFIX).subscribe(response => {
        if (response.isSuccess && response.statusCode === 200) {
          this.storageTypeDropdown = response.resources;
          this.rxjsService.setGlobalLoaderProperty(false);
        }
      });

    let params = new HttpParams().set('IsSAP', 'true')
    this.crudService.get(
      ModulesBasedApiSuffix.INVENTORY,
      InventoryModuleApiSuffixModels.STORAGE_LOCATIONS_SAP, undefined, true, params).subscribe(response => {
        if (response.isSuccess && response.statusCode === 200) {
          response.resources.forEach((item,index)=>{
            item.index = index
          })
          this.storageLocationDropdown = response.resources;
          this.storageLocationDropdown.sort((a, b) => a.index - b.index);
          this.rxjsService.setGlobalLoaderProperty(false);
        }
      });
  }
  getStorageLocationDropdown() {
    let params = new HttpParams().set('IsSAP', 'true')
    this.crudService.get(
      ModulesBasedApiSuffix.INVENTORY,
      InventoryModuleApiSuffixModels.STORAGE_LOCATIONS_SAP, undefined, true, params).subscribe(response => {
        if (response.isSuccess && response.statusCode === 200) {
          response.resources.forEach((item,index)=>{
            item.index = index
          })
          this.storageLocationDropdownTemp = response.resources;
          this.rxjsService.setGlobalLoaderProperty(false);
        }
      });
  }
  getSelectedLocations(event: any,isAdd=false) {
    this.crudService.get(
      ModulesBasedApiSuffix.INVENTORY,
      InventoryModuleApiSuffixModels.STORAGE_LOCATION, event.target.value).subscribe(response => {
        if (response.isSuccess && response.statusCode === 200 && response.resources != null) {
          if(isAdd){
            this.getSapLocaionAddForm.get('storageLocationId').patchValue(response.resources.storageLocationId);
            this.getSapLocaionAddForm.get('storageLocationName').patchValue(response.resources.storageLocationName);
            this.getSapLocaionAddForm.get('storageLocationCode').patchValue(response.resources.storageLocationCode);
            this.getSapLocaionAddForm.get('storageLocationPrefixId').patchValue(response.resources.storageLocationPrefixId);
            this.getSapLocaionAddForm.get('isActive').patchValue(response.resources.isActive);

          }else{
            this.getStorageSAPLocationFormArray.controls[0].get('storageLocationId').patchValue(response.resources.storageLocationId);
              this.getStorageSAPLocationFormArray.controls[0].get('storageLocationName').patchValue(response.resources.storageLocationName);
              this.getStorageSAPLocationFormArray.controls[0].get('storageLocationCode').patchValue(response.resources.storageLocationCode);
              this.getStorageSAPLocationFormArray.controls[0].get('storageLocationPrefixId').patchValue(response.resources.storageLocationPrefixId);
              this.getStorageSAPLocationFormArray.controls[0].get('isActive').patchValue(response.resources.isActive);
          }
          this.rxjsService.setGlobalLoaderProperty(false);
        }
      });
  }

  /* Create FormArray controls */
  createStorageCRMGroupForm(storageCRMLocationDetails?: StorageListAddModel): FormGroup {
    let structureTypeData = new StorageListAddModel(storageCRMLocationDetails ? storageCRMLocationDetails : undefined);
    let formControls = {};
    Object.keys(structureTypeData).forEach((key) => {
      formControls[key] = [{ value: structureTypeData[key], disabled: storageCRMLocationDetails && (key == '') && structureTypeData[key] !== '' ? true : false },
      ((key === 'storageLocationName' || key === 'isActive')  ? [Validators.required] : [])]
    });
    return this.formBuilder.group(formControls);
  }

  /* Create FormArray controls */
  createStorageSAPGroupForm(storageSAPLocationDetails?: SAPStorageListAddEditModel): FormGroup {
    let structureTypeData = new SAPStorageListAddEditModel(storageSAPLocationDetails ? storageSAPLocationDetails : undefined);
    let formControls = {};
    Object.keys(structureTypeData).forEach((key) => {
      formControls[key] = [{ value: structureTypeData[key], disabled: storageSAPLocationDetails && (key == '') && structureTypeData[key] !== '' ? true : false },
      ((key === 'storageLocationName' || key === 'isActive' || key === 'storageLocationId' || key === 'storageLocationPrefixId') ? [Validators.required]: [])]
    });
    return this.formBuilder.group(formControls);
  }

  /* Check duplicate value */
  duplicateValue() {
    const filterKey = [];
    const duplicate = [];
    let selectType = this.storageLocationAddEditForm.get('selectType').value;
    if (selectType) {
       let array = [...this.getStorageSAPLocationFormArray.value];
      array.push(this.getSapLocaionAddForm.value)
      array.filter((k) => {
        if (filterKey.includes(k.storageLocationName)) {
          duplicate.push(k.storageLocationName);
        }
        filterKey.push(k.storageLocationName);
      });
    }
    else {
      let  array1 = [...this.getStorageCRMLocationFormArray.value];
      array1.push(this.getCrmLocaionAddForm.value);
      array1.filter((k) => {
        if (filterKey.includes(k.storageLocationName)) {
          duplicate.push(k.storageLocationName);
        }
        filterKey.push(k.storageLocationName);
      });
    }
    return duplicate.length ? duplicate.join(",") : false;
  }

  onChange() {
    const duplicate = this.duplicateValue();
    if (duplicate) {
      this.snackbarService.openSnackbar(
        `Storage Location group already exist - ${duplicate}`,
        ResponseMessageTypes.WARNING
      );
      return false;
    }
    return true;
  }

  /* Add items */
  addStorageGroup(): void {
    let selectType = this.storageLocationAddEditForm.get('selectType').value;
    if (selectType) {
      if (!this.onChange() || this.getSapLocaionAddForm.invalid || !this.getSapLocaionAddForm.value?.storageLocationId) {
        return;
      }
      // this.showStorageCode = true;
      this.storageSAPLocationDetails = this.getStorageSAPLocationFormArray;
      let groupData = new SAPStorageListAddEditModel(this.getSapLocaionAddForm.value);
      this.storageSAPLocationDetails.push(this.createStorageSAPGroupForm(groupData));
      let val = this.getSapLocaionAddForm.value
      let index = this.storageLocationDropdown.findIndex(x => x.id == val.storageLocationId);
      this.storageLocationDropdown.splice(index, 1);
      this.getSapLocaionAddForm.reset()
      this.getSapLocaionAddForm.get("storageLocationName").setErrors(null)
      this.getSapLocaionAddForm.get("storageLocationId").setErrors(null)
      this.getSapLocaionAddForm.get("isActive").setErrors(null)
      this.getSapLocaionAddForm.get("storageLocationPrefixId").setErrors(null)
      this.getSapLocaionAddForm.get("storageLocationName").setValidators([Validators.required])

    }
    else {
      if (!this.onChange() || this.getCrmLocaionAddForm.invalid) {
        return;
      }
      this.storageCRMLocationDetails = this.getStorageCRMLocationFormArray;
      let groupData = new StorageListAddModel(this.getCrmLocaionAddForm.value);
      this.storageCRMLocationDetails.push(this.createStorageCRMGroupForm(groupData));
      this.getCrmLocaionAddForm.reset()
    }
  }

  /* Remove items */
  removeStorageGroup(i?: number) {
    let selectType = this.storageLocationAddEditForm.get('selectType').value;
    if (i !== undefined) {
      if (selectType) {
        let id = this.getStorageSAPLocationFormArray.controls[i].get('storageLocationId').value;
        let find = this.storageLocationDropdownTemp.find(x => x.id == id);
        this.storageLocationDropdown.push(find);
        this.storageLocationDropdown.sort((a, b) => a.index - b.index);
        this.getStorageSAPLocationFormArray.removeAt(i);
      }
      else {
        this.getStorageCRMLocationFormArray.removeAt(i);
      }
    }
  }

  beforeOnSubmit(type?) {
    let selectType = this.storageLocationAddEditForm.get('selectType').value;
    let form :FormGroup = selectType? this.getSapLocaionAddForm: this.getCrmLocaionAddForm
    let formArray :FormArray = selectType? this.getStorageSAPLocationFormArray: this.getStorageCRMLocationFormArray

    if (this.storageLocationsId && !this.storageLocationAddEditForm.dirty) { // For Update
      this.getSapLocaionAddForm.get("storageLocationName").setErrors(null)
      this.getSapLocaionAddForm.get("storageLocationId").setErrors(null)
      this.getSapLocaionAddForm.get("isActive").setErrors(null)
      this.getSapLocaionAddForm.get("storageLocationPrefixId").setErrors(null)
      return this.snackbarService.openSnackbar("No changes were detected", ResponseMessageTypes.WARNING)
    }

    if (formArray.value.length == 0) {
      this.snackbarService.openSnackbar("Please add at least one record", ResponseMessageTypes.WARNING)
      return;
    }
    let locationId = selectType? form.value.storageLocationId : "" // If SAP Storage Checking storageLocationId seleced or NOT
    if (!form.invalid && !this.storageLocationsId && (!selectType || locationId)) { // form is Valid & Create  && checked type and ID for SAP Storage
      let customText = "<b>Changes you made will not be saved. <br> Do you want to continue?</b>"
      const confirm = this.dialogService.open(PrimengCustomDialogComponent, {
        header: `Unsaved Changes`,
        showHeader: false,
        closable: true,
        baseZIndex: 10000,
        width: '400px',
        data: { customText: customText ,isShowImage:true},
      });
      confirm.onClose.subscribe((resp) => {
        if (resp === false) {
          this.onSubmit()
        }
      })

    } else {
      this.onSubmit()
    }
  }

  /* Onsubmit function*/
  onSubmit() {
    this.getStorageSAPLocationFormArray.clearValidators();
    this.getStorageCRMLocationFormArray.clearValidators();
    let selectType = this.storageLocationAddEditForm.get('selectType').value;
    let formarry;
    if (selectType) {
      if (!this.onChange() || this.getStorageSAPLocationFormArray.invalid) {
        return;
      }
      if(this.getStorageSAPLocationFormArray.value.length ==0){
        return this.snackbarService.openSnackbar("Add at least one record", ResponseMessageTypes.WARNING)
      }

      this.getSapLocaionAddForm.get("storageLocationName").setErrors(null)
      this.getSapLocaionAddForm.get("storageLocationId").setErrors(null)
      this.getSapLocaionAddForm.get("isActive").setErrors(null)
      this.getSapLocaionAddForm.get("storageLocationPrefixId").setErrors(null)
      formarry = this.getStorageSAPLocationFormArray.value;
    }
    else {
      if (!this.onChange() || this.getStorageCRMLocationFormArray.invalid) {
        return;
      }
      if(this.getStorageCRMLocationFormArray.value.length ==0){
        return this.snackbarService.openSnackbar("Please add at least one record", ResponseMessageTypes.WARNING)
      }

      this.getCrmLocaionAddForm.get("storageLocationName").setErrors(null)
      this.getCrmLocaionAddForm.get("isActive").setErrors(null)
      formarry = this.getStorageCRMLocationFormArray.value;
    }

    let formarryTemp = [];
    formarry.forEach((key) => {
      if (this.storageLocationsId) {
        key["modifiedUserId"] = this.loggedUser.userId;
      }
      else {
        key["createdUserId"] = this.loggedUser.userId;
      }
      if (selectType) {
        key['storageType'] = key.storageLocationPrefixId;
        key['storageLocationTypeId'] = 10;
        key["isCRM"] = false;
        key["isSAP"] = true;
      }
      else {
        key["isSAP"] = false;
        key["isCRM"] = true;
      }
      if ((key.isActive == false || key.isActive == "false" || key.isActive == true || key.isActive == "true") && key.isActive != "") {
        formarryTemp.push(key)
      }
    });
    if (!formarryTemp || formarryTemp.length == 0) {
      this.snackbarService.openSnackbar("Please add atleast one storage details.", ResponseMessageTypes.WARNING);
      return;
    }
    this.rxjsService.setFormChangeDetectionProperty(true);
    const submit$ = this.storageLocationsId ? this.crudService.update(
      ModulesBasedApiSuffix.INVENTORY,
      InventoryModuleApiSuffixModels.STORAGE_LOCATION,
      formarryTemp[0]
    ) : this.crudService.create(
      ModulesBasedApiSuffix.INVENTORY,
      InventoryModuleApiSuffixModels.STORAGE_LOCATION,
      formarryTemp
    );
    submit$.pipe(tap(() => {
      this.rxjsService.setGlobalLoaderProperty(false);
    })).subscribe((response) => {
      if (response.isSuccess && response.statusCode == 200) {
        this.navigateToListPage();
      }
    });
  }

  navigateToListPage(): void {
    this.router.navigate(['/inventory/warehouse'], { queryParams: { tab: 1 } });
  }

}
